function createEducationReportMetrics(item) {
  return [
    { id: 'completed', label: 'Всего пройдено', value: String(item.completedTrainings) },
    {
      id: 'expired',
      label: 'Просрочено',
      value: String(item.expiredTrainings),
      danger: item.expiredTrainings > 0,
    },
    {
      id: 'index',
      label: 'Индекс обучения',
      value: item.trainingIndex.toFixed(1),
      danger: item.trainingIndex < 70,
    },
    {
      id: 'engagement',
      label: 'Вовлеченность',
      value: `${item.engagement}%`,
      danger: item.engagement < 60,
    },
  ];
}

export const EDUCATION_TEST_REPORT_POINT_FILTERS = [
  { id: 'point-breeze', label: 'Кафе "Бриз"' },
  { id: 'point-river', label: 'Кафе "Ривер"' },
  { id: 'point-north', label: 'Кафе "Север"' },
];

export const EDUCATION_TEST_REPORT_POINTS = [
  {
    id: 'point-breeze',
    name: 'Кафе "Бриз"',
    meta: ['Москва', '24 сотрудника'],
    completedTrainings: 1245,
    expiredTrainings: 4,
    trainingIndex: 70.5,
    averageScore: 85,
    engagement: 95,
  },
  {
    id: 'point-river',
    name: 'Кафе "Ривер"',
    meta: ['Казань', '18 сотрудников'],
    completedTrainings: 940,
    expiredTrainings: 1,
    trainingIndex: 82.1,
    averageScore: 103,
    engagement: 97,
  },
  {
    id: 'point-north',
    name: 'Кафе "Север"',
    meta: ['Санкт-Петербург', '16 сотрудников'],
    completedTrainings: 812,
    expiredTrainings: 0,
    trainingIndex: 76.3,
    averageScore: 100,
    engagement: 91,
  },
].map((point) => ({
  ...point,
  metrics: createEducationReportMetrics(point),
}));

export const EDUCATION_TEST_REPORT_EMPLOYEES = [
  {
    id: 'employee-evgenev-1',
    pointId: 'point-breeze',
    name: 'Евгений Евгеньев',
    meta: ['Официант', 'Кафе "Бриз"'],
    completedTrainings: 210,
    expiredTrainings: 2,
    trainingIndex: 95,
    averageScore: 90,
    engagement: 95,
  },
  {
    id: 'employee-evgenev-2',
    pointId: 'point-breeze',
    name: 'Евгений Евгеньев',
    meta: ['Официант', 'Кафе "Бриз"'],
    completedTrainings: 180,
    expiredTrainings: 0,
    trainingIndex: 32.4,
    averageScore: 76,
    engagement: 58,
  },
  {
    id: 'employee-evgenev-3',
    pointId: 'point-breeze',
    name: 'Евгений Евгеньев',
    meta: ['Официант', 'Кафе "Бриз"'],
    completedTrainings: 235,
    expiredTrainings: 1,
    trainingIndex: 88,
    averageScore: 88,
    engagement: 93,
  },
  {
    id: 'employee-evgenev-4',
    pointId: 'point-river',
    name: 'Евгений Евгеньев',
    meta: ['Официант', 'Кафе "Ривер"'],
    completedTrainings: 190,
    expiredTrainings: 0,
    trainingIndex: 82,
    averageScore: 84,
    engagement: 95,
  },
  {
    id: 'employee-evgenev-5',
    pointId: 'point-river',
    name: 'Евгений Евгеньев',
    meta: ['Официант', 'Кафе "Ривер"'],
    completedTrainings: 250,
    expiredTrainings: 0,
    trainingIndex: 86,
    averageScore: 92,
    engagement: 98,
  },
  {
    id: 'employee-evgenev-6',
    pointId: 'point-north',
    name: 'Евгений Евгеньев',
    meta: ['Официант', 'Кафе "Север"'],
    completedTrainings: 180,
    expiredTrainings: 3,
    trainingIndex: 87.6,
    averageScore: 80,
    engagement: 90,
  },
].map((employee) => ({
  ...employee,
  metrics: createEducationReportMetrics(employee),
}));

export const EDUCATION_TEST_REPORT_SUMMARY_CARD_DEFINITIONS = [
  {
    id: 'completed-trainings',
    title: 'Всего обучений пройдено',
    metric: 'completedTrainings',
    aggregation: 'sum',
    trend: 'up',
  },
  {
    id: 'training-index',
    title: 'Индекс обучения',
    metric: 'trainingIndex',
    aggregation: 'average',
    trendRule: 'training-index',
  },
  {
    id: 'average-score',
    title: 'Средний балл',
    metric: 'averageScore',
    aggregation: 'average-percent',
    trendRule: 'average-score',
  },
];

export const EDUCATION_TEST_REPORT = {
  pointFilterAllLabel: 'Все точки',
  periodLabel: 'Период',
  exportLabel: 'Экспорт',
  activeSegmentId: 'employees',
  activePointId: 'all',
  pointFilters: EDUCATION_TEST_REPORT_POINT_FILTERS,
  summaryCardDefinitions: EDUCATION_TEST_REPORT_SUMMARY_CARD_DEFINITIONS,
  segments: [
    {
      id: 'points',
      label: 'Точки продаж',
      items: EDUCATION_TEST_REPORT_POINTS,
    },
    {
      id: 'employees',
      label: 'Сотрудники',
      items: EDUCATION_TEST_REPORT_EMPLOYEES,
    },
  ],
};
